import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {PdfViewerComponent} from 'ng2-pdf-viewer';
import Viewer from 'viewerjs';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-modal-image-viewer',
  templateUrl: './modal-image-viewer.component.html',
  styles: []
})
export class ModalImageViewerComponent extends ExcTranslation implements OnInit {

  @ViewChild('imgHost') imgHost!: ElementRef<HTMLImageElement>;
  @ViewChild('vidHost') vidHost!: ElementRef<HTMLVideoElement>;
  @ViewChild(PdfViewerComponent) pdfViewerComponent!: PdfViewerComponent;

  //@Input() data: { objID: string, attID?: string, CustomAction?: { caption: string, click: (item: any) => {} }, [key: string]: any } = {objID: '', attID:''};
  @Input() data: {jagData: any, attID: string, CustomAction?: { caption: string, click: (item: any) => {} }, [key: string]: any } = {jagData: [], attID:''};

  resourceIdentifier = 'dokID';
  ID: any;

  uiSelectDocumentTypeIndex = this.enumSvc.getEnumerationList('DokTyp').findIndex(e => e.enmDefault);

  uiModel = {
    dokTrackingPortalShare: false,
    dokBeschreibung: '',
    dok_enmIdent_DokTyp: 1,
    dokName: '',
    DokEigenschaft: [] as any[]
  };

  attachmentList = {
    data: [] as any[]
  };


  dokEigenschaftHelper: any = {};

  _galleryData: any [] = [];
  set galleryData(value: any[]) {
    this._galleryData = value;
  }

  get galleryData(): any[] {
    return this._galleryData;
  }

  currentIndex = -1;
  throttleId: any;
  throttle = 80;
  notSupportedMIME = false;
  supportedMIMEs: string[] = [
    'image/.*',
    'video/.*',
    'application/pdf'
  ];

  get galleryDataCount(): number {
    return this.galleryData.length;
  }

  get currentItem(): any {
    return this.galleryData[this.currentIndex];
  }

  _resourcesData: { [key: string]: any } = {};

  get currentResource(): any {
    if (this.currentItem) {
      return this._resourcesData[this.currentItem[this.resourceIdentifier]];
    } else {
      return undefined;
    }
  }

  set currentResource(value: any) {
    this._resourcesData[this.currentItem[this.resourceIdentifier]] = value;
  }

  viewer: Viewer | null = null;
  isLoading = true;

  constructor(public modalService: ExgModalService,
              private excRestService: ExcRestService,
              public excSecurity: ExcSecurityService,
              public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {

    // @ts-ignore
   /* this.data.jagData.forEach((el) => {
      el.documents.forEach((doc: any) => {
        doc.dok_enmIdent_DokTyp = el.dok_enmIdent_DokTyp;
      });
      this.attachmentList.data.push(...el.documents);
    });

    if (!this.attachmentList.data) {
      this.stopLoadingAnimation();
      return;
    }
    this.galleryData = this.attachmentList.data.filter((e: any) => {
      if (!this.data.allowedMIME) {
        this.stopLoadingAnimation();
        return true;
      }
      return this.data.allowedMIME.some((mime: any) => new RegExp(mime).test(e.dokMIME));
      this.stopLoadingAnimation();
    });
    if (this.galleryDataCount > 0) {
      this.stopLoadingAnimation();

      if(this.data.attID !== '' && this.data.attID) {
        this.galleryData.forEach((value, index) =>{
          if(value.dokID === this.data.attID){
            this.currentIndex = index;
          }
        })
      }
      else {
        this.currentIndex = 0; // initial index setzen
      }

      setTimeout(() => this.showIndex(this.currentIndex), 100);
    }*/
    if (this.data.otherMime) {
      this.galleryData = this.data.otherMime;
      this.currentIndex = this.data.attID ? this.galleryData.findIndex(item => item.dokID === this.data.attID) : 0;
      setTimeout(() => this.showIndex(this.currentIndex), 100);
      this.stopLoadingAnimation();
      return;
    }
    if (this.data.isTemplate && this.data.attID) {
      const mime = this.data.templateMime
        ? (this.data.templateMime === 'pdf' ? 'application/pdf' : 'image/' + this.data.templateMime)
        : 'image/jpeg';

      this.galleryData = [{
        dokID: this.data.attID,
        dokMIME: mime,
        dokName: 'Template'
      }];
      this.currentIndex = 0;
      setTimeout(() => this.showIndex(this.currentIndex), 100);
      this.stopLoadingAnimation();
      return;
    }
    if (this.data.attID && this.data.attID !== '00000000-0000-0000-0000-000000000000') {
      const fallback = () => {
        this.galleryData = [{dokID: this.data.attID, dokMIME: 'image/jpeg', dokName: 'Objektbild'}];
        this.currentIndex = 0;
        setTimeout(() => this.showIndex(this.currentIndex), 100);
        this.stopLoadingAnimation();
      };

      if (this.data.objID) {
        this.excRestService.get(this.excRestService.computeUrl('DocumentR_List', {objID: this.data.objID})).subscribe(
          (response: any) => {
            const foundDoc = response.success &&
              response.data?.documents &&
              response.data.documents.find((doc: any) => doc.dokID === this.data.attID);

            if (foundDoc) {
              this.galleryData = response.data.documents;
              this.currentIndex = this.galleryData.findIndex(doc => doc.dokID === this.data.attID);
            } else {
              this.galleryData = [{dokID: this.data.attID, dokMIME: 'image/jpeg', dokName: 'Objektbild'}];
              this.currentIndex = 0;
            }

            setTimeout(() => this.showIndex(this.currentIndex), 100);
            this.stopLoadingAnimation();
          }
        );
      } else {
        fallback();
      }
      return;
    }

    this.excRestService.get(this.excRestService.computeUrl('DocumentR_List', {objID: this.data.objID})).subscribe((response: any) => {
      if (!response.success) {
        this.stopLoadingAnimation();
        return;
      }
      this.galleryData = response.data.documents.filter((e: any) => {
        if (!this.data.allowedMIME) {
          this.stopLoadingAnimation();
          return true;
        }
        return this.data.allowedMIME.some((mime: any) => new RegExp(mime).test(e.dokMIME));
        this.stopLoadingAnimation();
      });
      if (this.galleryDataCount > 0) {
        this.currentIndex = this.data.attID && this.data.attID !== ''
          ? this.galleryData.findIndex(value => value.dokID === this.data.attID) || 0 : 0;
        setTimeout(() => this.showIndex(this.currentIndex), 100);
      }
      this.stopLoadingAnimation();
    });

  }

  setDocumentType(e: any): void {
    this.uiSelectDocumentTypeIndex = e;
    this.uiModel.dok_enmIdent_DokTyp = this.enumSvc.getEnumerationList('DokTyp')[e]['enmIdent'];
    this.uiModel.dokTrackingPortalShare = this.currentItem.dokTrackingPortalShare;
    this.uiModel.dokBeschreibung = this.currentItem.dokBeschreibung;
    this.uiModel.dokName = this.currentItem.dokName;
    this.uiModel.DokEigenschaft = [];
    for(const key in this.dokEigenschaftHelper) {
      this.uiModel.DokEigenschaft.push({dokEigID: key as unknown as number, dokEigValue: this.dokEigenschaftHelper[key]})
    }
  }

  initImageViewer(): void {
    this.destroyImageViewer();
    this.viewer = new Viewer(this.imgHost.nativeElement, {
      // inheritedAttributes: [],
      inline: true,
      title: false,
      navbar: false,
      toolbar: {
        zoomIn: true,
        zoomOut: true,
        oneToOne: true,
        reset: true,
        prev: false,
        play: false,
        next: false,
        rotateLeft: true,
        rotateRight: true,
        flipHorizontal: true,
        flipVertical: true
      },
      button: false,
      fullscreen: true,
      transition: false
    });
  }

  showIndex(currentIndex: number): void {

    // -- set always to false to avoid rendering of the wrong mime hint
    this.notSupportedMIME = false;

    this.uiSelectDocumentTypeIndex = this.enumSvc.getEnumerationList('DokTyp').findIndex(e => e.enmIdent === this.currentItem.dok_enmIdent_DokTyp);

    if (this.throttleId) {
      clearTimeout(this.throttleId);
    }

    this.throttleId = setTimeout(async () => {
      this.startLoadingAnimation();

      // -- check if this data is supported
      if (!this.isMIMESupported()) {
        this.notSupportedMIME = true;
        this.stopLoadingAnimation();
      } else {
        this.notSupportedMIME = false;
      }
      // -- load resource
      if (!this.currentResource) {
        this.currentResource = await this.getCurrentResourceBinary();
      }

      // reinit image viewer if currentResource is an image
      if (this.isCurrentItemImage()) {
        setTimeout(() => this.initImageViewer(), 200);
      } else {
        this.destroyImageViewer();
      }

      // start video player
      if (this.isCurrentItemVideo()) {
        this.vidHost.nativeElement.load();
      }

      this.stopLoadingAnimation();
    }, this.throttle);

  }

  showPrev(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.showIndex(this.currentIndex);
    }
  }

  showNext(): void {
    if (this.currentIndex < this.galleryDataCount - 1) {
      this.currentIndex++;
      this.showIndex(this.currentIndex);
    }
  }

  destroyImageViewer(): void {
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
  }

  save(): void {
    this.excRestService.post(
      this.excRestService.computeUrl('DocumentU', {dokID: this.currentItem.dokID}), this.uiModel
    ).subscribe((ret: any) => {
      if (ret) {
        this.modalService.action(this.uiModel);
      }
      else { this.close(); }
    });
  }

  close(): void {
    this.modalService.close();
  }

  private startLoadingAnimation(): void {
    this.isLoading = true;
  }

  private stopLoadingAnimation(): void {
    this.isLoading = false;
  }

  isMIMESupported(): boolean {
    return this.supportedMIMEs.some(mime => new RegExp(mime).test(this.currentItem.dokMIME));
  }

  isCurrentItemVideo(): boolean {
    return this.currentItem.dokMIME.indexOf('video/') > -1;
  }

  isCurrentItemImage(): boolean {
    return this.currentItem.dokMIME.indexOf('image/') > -1;
  }

  isCurrentItemPDF(): boolean {
    return this.currentItem.dokMIME.indexOf('application/pdf') > -1;
  }

  async getCurrentResourceBinary(): Promise<any> {

    const queryParams: { [key: string]: any } = {
        dokID: this.currentItem.dokID
    };

    if (this.data.stempelPreview) {
      const stempelurl = this.excRestService.computeUrl('UserStempelR', { stpID: this.currentItem.dokID });
      const stempelresponse = await this.excRestService.sget(stempelurl, 'test', {}).toPromise();
      return 'data:' + this.currentItem.dokMIME + ';base64,' + stempelresponse.data.IMG;
    }

    if (this.data.isTemplate) {
      queryParams.streamId = this.currentItem.dokID;
      delete queryParams.dokID;

      if (this.isCurrentItemVideo() || this.isCurrentItemPDF()) {
        queryParams.video = true;
        return this.excRestService.computeUrl('ReportTemplateR', queryParams);
      }

      const templateUrl = this.excRestService.computeUrl('ReportTemplateR', queryParams);
      const templateResponse = await this.excRestService.sget(templateUrl, 'test', {}).toPromise();

      if (this.isCurrentItemImage()) {
        const imageData = templateResponse.data?.file_stream || templateResponse.data?.IMG;
        if (imageData) {
          return 'data:' + this.currentItem.dokMIME + ';base64,' + imageData;
        }
      }
      return templateResponse;
    }
    // for video and pdf stream url request
    if (this.isCurrentItemVideo() || this.isCurrentItemPDF()) {
      const vidQuery = 'video';
      queryParams[vidQuery] = true;
      return this.excRestService.computeUrl('DocumentR', queryParams);
    }

    const url = this.excRestService.computeUrl('DocumentR', queryParams);
    const response = await this.excRestService.sget(url, 'test', {}).toPromise();

    // for image request
    if (this.isCurrentItemImage()) {
      return 'data:' + this.currentItem.dokMIME + ';base64,' + response.data.IMG;
    }
    return response;
  }

  customAction(item: any): void {
   this.data.CustomAction?.click(item);
   this.modalService.close();
  }

  downloadDocument(): void {
    const queryParams: { [key: string]: any } = {
      dokID: this.currentItem.dokID
    };

    queryParams["export"] = true;

    // for video and pdf stream url request
    if (this.isCurrentItemVideo() || this.isCurrentItemPDF()) {
      queryParams['video'] = true;
      // this.excRestService.computeUrl('DocumentR', queryParams);
    }
      this.excRestService.get(this.excRestService.computeUrl('DocumentR', queryParams),
      {export: true}).subscribe();
  }

}
